import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SliderComponent } from '@questions/single-select-questions/slider/slider.component';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { SingleSelect } from '@shared/models/question-types/single-select';
import { ValidatorComponent } from '../../../validator/validator.component';
import { QuestionBaseComponent } from '../../question-base/question-base.component';

@Component({
  selector: 'app-nps',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    QuestionBaseComponent,
    ValidatorComponent,
    SliderComponent,
  ],
  templateUrl: './nps.component.html',
  styleUrl: './nps.component.scss',
})
export class NpsComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) question!: SingleSelect;
  @Input({ required: true }) control!: any;
  @Input() isFirstQuestion: boolean = false;
  @Input() displayAsSlider: boolean = false;
  ValidatorType = ValidatorType;

  @ViewChild('npsOptions') npsOptions?: ElementRef<HTMLElement>;
  isVerticalLayout: boolean = false;

  private static readonly TILE_WIDTH_PX = 56;
  private static readonly TILE_GAP_PX = 8;
  private resizeObserver?: ResizeObserver;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.displayAsSlider) return;

    const optionsElement = this.npsOptions?.nativeElement;
    if (!optionsElement) return;

    this.resizeObserver = new ResizeObserver(() => {
      this.updateLayout();
    });
    this.resizeObserver.observe(optionsElement);
    this.updateLayout();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  toggleSelection(value: string) {
    if (this.control.value === value) {
      this.clearValue();
    } else {
      this.control.setValue(value);
    }
  }

  clearValue() {
    this.control.setValue('');
    this.control.markAsUntouched();
  }

  handleKeydown(event: KeyboardEvent, value: string) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleSelection(value);
    }
  }

  private updateLayout(): void {
    const availableWidth = this.npsOptions?.nativeElement.clientWidth ?? 0;
    this.updateLayoutForAvailableWidth(availableWidth);
  }

  private updateLayoutForAvailableWidth(availableWidth: number): void {
    const count = this.question.alternatives?.length ?? 0;

    if (count === 0 || availableWidth <= 0) {
      this.isVerticalLayout = false;
      this.cdr.detectChanges();
      return;
    }

    const requiredWidth =
      count * NpsComponent.TILE_WIDTH_PX +
      (count - 1) * NpsComponent.TILE_GAP_PX;

    this.isVerticalLayout = availableWidth < requiredWidth;
    this.cdr.detectChanges();
  }
}
